import { CropConnectTaskDto } from '../services/cropConnectApiClient';

export const combineDateAndTimeToISO = (
  date: Date | null,
  time: string
): string => {
  if (!date || !time) return new Date().toISOString();
  const [hours, minutes] = time.split(':').map(Number);
  const combinedDate = new Date(date);
  combinedDate.setHours(hours, minutes, 0, 0);
  return combinedDate.toISOString();
};

export const formatDateTime = (isoString: string): string => {
  const date = new Date(isoString);
  return date.toLocaleString();
};

export const isTaskActive = (task: CropConnectTaskDto): boolean => {
  const today = new Date();
  const startDate = new Date(task.startDate ?? '');
  const endDate = new Date(task.endDate ?? '');
  return startDate <= today && endDate >= today;
};
